export const routeStatisticsCs = {
  navigationLabel: 'Statistiky linek',
  backToMap: 'Zpět na mapu',
  eyebrow: 'Analýza linek',
  title: 'Statistiky linek',
  description: 'Spolehlivost, zpoždění, pravidelnost, provoz i délka jednotlivých linek.',
  metric: 'Metrika',
  period: 'Období',
  period_today: 'Dnes',
  period_7d: '7 dní',
  period_28d: '28 dní',
  period_90d: '90 dní',
  ranking: 'Pořadí linek',
  routeCount: '{count} linek',
  loading: 'Připravuji statistiky linek…',
  loadError: 'Statistiky linek se teď nepodařilo načíst.',
  empty: 'Pro zvolené období nejsou dostupná data linek.',
  emptyRange: 'Pro období {from}–{to} nejsou dostupná agregovaná data linek.',
  emptyPartial: 'Zdroj označil toto období jako neúplné.',
  show28d: 'Zobrazit 28 dní',
  detail: 'Detail linky',
  metric_reliability: 'Spolehlivost linky',
  metric_delayAccumulation: 'Nárůst zpoždění během trasy',
  metric_problemSegments: 'Nejproblematičtější úsek',
  metric_travelTime: 'Skutečná jízdní doba',
  metric_regularity: 'Nepravidelnost intervalů',
  metric_bunching: 'Vláčkování spojů',
  metric_worstPeriod: 'Nejhorší hodina a den',
  metric_stability: 'Stabilita linky',
  metric_periodChange: 'Změna proti minulému období',
  metric_directionDifference: 'Rozdíl mezi směry',
  metric_affectedRouteShare: 'Podíl problémové trasy',
  metric_serviceVolume: 'Objem provozu',
  metric_problemTrips: 'Problematické spoje',
  metric_recovery: 'Odolnost linky',
  metric_networkUniqueness: 'Unikátnost v síti',
  metric_routeLength: 'Délka linky',
  metric_scheduledDuration: 'Plánovaná délka jízdy',
  help_reliability: 'Podíl průjezdů zastávkou v toleranci od −1 do +3 minut.',
  help_delayAccumulation: 'Průměrný rozdíl zpoždění mezi začátkem a koncem pozorované jízdy.',
  help_problemSegments: 'Největší průměrný nárůst zpoždění na jednom úseku linky.',
  help_travelTime: 'Průměrná skutečná doba celé pozorované jízdy linky.',
  help_regularity: 'Variační koeficient skutečných rozestupů spojů; nižší je pravidelnější.',
  help_bunching: 'Podíl rozestupů nejvýše polovičních proti jízdnímu řádu.',
  help_worstPeriod: 'Hodina a provozní den s největším průměrným nárůstem zpoždění.',
  help_stability: 'Kolísání průměrného nárůstu zpoždění mezi jednotlivými dny.',
  help_periodChange: 'Rozdíl proti bezprostředně předchozímu stejně dlouhému období.',
  help_directionDifference: 'Rozdíl průměrného nárůstu zpoždění mezi oběma směry.',
  help_affectedRouteShare: 'Podíl měřených úseků, na kterých zpoždění v průměru narůstá.',
  help_serviceVolume: 'Počet zaznamenaných jízd linky ve zvoleném období.',
  help_problemTrips: 'Podíl jízd, které mezi začátkem a koncem nabraly alespoň 3 minuty.',
  help_recovery: 'Podíl zpožděných jízd, které během trasy část zpoždění dohnaly.',
  help_networkUniqueness: 'Podíl úseků linky, které ve zvoleném období nesdílela s jinou linkou.',
  help_routeLength: 'Nejdelší pravidelná varianta linky podle aktuální trasy.',
  help_scheduledDuration: 'Typická plánovaná doba celé jízdy podle jízdního řádu.',
  reliability: 'V toleranci',
  medianDelay: 'Medián zpoždění',
  p90Delay: '90. percentil zpoždění',
  delayAccumulation: 'Nárůst za jízdu',
  worstSegment: 'Nejhorší úsek',
  travelTime: 'Skutečná jízdní doba',
  p90TravelTime: '90. percentil jízdní doby',
  regularity: 'Nepravidelnost',
  bunching: 'Vláčkování',
  worstHour: 'Nejhorší hodina',
  worstDay: 'Nejhorší den',
  stability: 'Kolísání mezi dny',
  periodChange: 'Proti minulému období',
  directionDifference: 'Rozdíl směrů',
  affectedRouteShare: 'Problematické úseky',
  serviceVolume: 'Pozorované jízdy',
  problemTrips: 'Jízdy s nárůstem ≥ 3 min',
  recovery: 'Dohnání části zpoždění',
  networkUniqueness: 'Unikátní úseky',
  routeLength: 'Délka trasy',
  scheduledDuration: 'Plánovaná doba',
  activeVehicles: 'Vozidel ve špičkovém dni',
  completeTrips: 'Úplné jízdy',
  sharedRoutes: 'Sdíleno s linkami',
  measuredTrips: '{count} měřených jízd',
  segmentsTitle: 'Nejproblematičtější úseky linky',
  segmentsDescription: 'Úseky jsou řazeny podle průměrného nárůstu zpoždění. Délka pruhu ukazuje jejich vzájemný poměr v rámci linky.',
  noSegments: 'Pro linku nejsou dostupné použitelné úsekové vzorky.',
  passages: '{count} průjezdů',
  samples: '{count} vzorků',
  directionsTitle: 'Porovnání směrů',
  direction: 'Směr {id}',
  towards: 'směr {headsign}',
  partialData: 'Období obsahuje neúplný nebo dosud přepočítávaný provozní den.',
  value_reliability: '{value} % v toleranci',
  value_delay: '{value}',
  value_problemSegments: '{value}',
  value_travelTime: '{value}',
  value_regularity: '{value} %',
  value_bunching: '{value} %',
  value_worstPeriod: '{value} · {hour}',
  value_stability: '{value}',
  value_periodChange: '{value}',
  value_directionDifference: '{value}',
  value_affectedRouteShare: '{value} % trasy',
  value_serviceVolume: '{value} jízd',
  value_problemTrips: '{value} % jízd',
  value_recovery: '{value} % jízd',
  value_networkUniqueness: '{value} % trasy',
  value_routeLength: '{value} km',
  value_scheduledDuration: '{value}',
}

export const routeStatisticsEn = {
  navigationLabel: 'Route statistics',
  backToMap: 'Back to map',
  eyebrow: 'Route analysis',
  title: 'Route statistics',
  description: 'Reliability, delay, regularity, service volume, and length of individual routes.',
  metric: 'Metric',
  period: 'Period',
  period_today: 'Today',
  period_7d: '7 days',
  period_28d: '28 days',
  period_90d: '90 days',
  ranking: 'Route ranking',
  routeCount: '{count} routes',
  loading: 'Preparing route statistics…',
  loadError: 'Route statistics could not be loaded right now.',
  empty: 'No route data is available for the selected period.',
  emptyRange: 'No aggregated route data is available for {from}–{to}.',
  emptyPartial: 'The source marked this period as incomplete.',
  show28d: 'Show 28 days',
  detail: 'Route detail',
  metric_reliability: 'Route reliability',
  metric_delayAccumulation: 'Delay gained over the journey',
  metric_problemSegments: 'Worst segment',
  metric_travelTime: 'Observed travel time',
  metric_regularity: 'Headway irregularity',
  metric_bunching: 'Service bunching',
  metric_worstPeriod: 'Worst hour and day',
  metric_stability: 'Route stability',
  metric_periodChange: 'Change against prior period',
  metric_directionDifference: 'Direction difference',
  metric_affectedRouteShare: 'Affected route share',
  metric_serviceVolume: 'Service volume',
  metric_problemTrips: 'Problem services',
  metric_recovery: 'Route resilience',
  metric_networkUniqueness: 'Network uniqueness',
  metric_routeLength: 'Route length',
  metric_scheduledDuration: 'Scheduled journey length',
  help_reliability: 'Share of stop passages within −1 to +3 minutes of schedule.',
  help_delayAccumulation: 'Average delay difference between the beginning and end of an observed journey.',
  help_problemSegments: 'Largest average delay gain on one segment of the route.',
  help_travelTime: 'Average observed duration of a complete route journey.',
  help_regularity: 'Coefficient of variation of actual headways; lower is more regular.',
  help_bunching: 'Share of headways no more than half their scheduled length.',
  help_worstPeriod: 'Clock hour and service day with the highest average delay gain.',
  help_stability: 'Variation in average delay gain from one day to another.',
  help_periodChange: 'Difference against the immediately preceding period of equal length.',
  help_directionDifference: 'Difference in average delay gain between both directions.',
  help_affectedRouteShare: 'Share of measured segments where delay grows on average.',
  help_serviceVolume: 'Number of recorded route journeys in the selected period.',
  help_problemTrips: 'Share of journeys that gained at least 3 minutes end to end.',
  help_recovery: 'Share of delayed journeys that recovered some delay along the route.',
  help_networkUniqueness: 'Share of route segments not shared with another route in the period.',
  help_routeLength: 'Longest regular variant of the route based on the current shape.',
  help_scheduledDuration: 'Typical scheduled duration of a complete journey.',
  reliability: 'Within tolerance', medianDelay: 'Median delay', p90Delay: '90th delay percentile',
  delayAccumulation: 'Journey delay gain', worstSegment: 'Worst segment', travelTime: 'Observed travel time',
  p90TravelTime: '90th travel-time percentile', regularity: 'Irregularity', bunching: 'Bunching',
  worstHour: 'Worst hour', worstDay: 'Worst day', stability: 'Day-to-day variation',
  periodChange: 'Against prior period', directionDifference: 'Direction difference',
  affectedRouteShare: 'Affected segments', serviceVolume: 'Observed journeys',
  problemTrips: 'Journeys gaining ≥ 3 min', recovery: 'Recovered some delay',
  networkUniqueness: 'Unique segments', routeLength: 'Route length', scheduledDuration: 'Scheduled duration',
  activeVehicles: 'Vehicles on busiest day', completeTrips: 'Complete journeys', sharedRoutes: 'Shared with routes',
  measuredTrips: '{count} measured journeys', segmentsTitle: 'Worst route segments',
  segmentsDescription: 'Segments are ordered by average delay gain. Bar length compares them within this route.',
  noSegments: 'No usable segment samples are available for this route.', passages: '{count} passages',
  samples: '{count} samples', directionsTitle: 'Direction comparison', direction: 'Direction {id}',
  towards: 'towards {headsign}', partialData: 'The period contains an incomplete or still-recalculating service day.',
  value_reliability: '{value}% within tolerance', value_delay: '{value}', value_problemSegments: '{value}',
  value_travelTime: '{value}', value_regularity: '{value}%', value_bunching: '{value}%',
  value_worstPeriod: '{value} · {hour}', value_stability: '{value}', value_periodChange: '{value}',
  value_directionDifference: '{value}', value_affectedRouteShare: '{value}% of route',
  value_serviceVolume: '{value} journeys', value_problemTrips: '{value}% of journeys',
  value_recovery: '{value}% of journeys', value_networkUniqueness: '{value}% of route',
  value_routeLength: '{value} km', value_scheduledDuration: '{value}',
}
